<template>
  <div :class="['sub-section-container', {'spread-line': $props.showSpread}]">
    <div style="display: flex; justify-content: space-between; align-items: center;">
      <div class="sub-section-title">
        <h2 class="title" v-if="$props.title">{{ $t($props.title) }}</h2>
        <div class="desc">{{ $t($props.desc) }}</div>
      </div>
      <slot name="header"></slot>
    </div>
    <slot name="description"></slot>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SubSection',
  props: {
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    showSpread: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="less" scoped>
.sub-section-container {
  padding-bottom: 40px;
  .sub-section-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    // padding-bottom: 40px;

    .title {
      position: relative;
      color: #131523;
      font-size: 16px;
      line-height: 16px;
      font-weight: 500;
      display: flex;
      align-items: center;
      &::before {
        position: absolute;
        left: -13px;
        content: '';
        display: inline-block;
        width: 2px;
        height: 16px;
        background-color: #4a6aff;
      }
    }
    .desc {
      font-size: 14px;
      font-weight: 300;
      color: #a1a7c4;
      line-height: 16px;
    }
  }
}
.spread-line {
  border-bottom: 1px solid #e6e9f4;
  margin-bottom: 40px;
}
</style>
